// extracted by mini-css-extract-plugin
export default {"appItem":"AppList_appItem__0rbN5"};